import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const login = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  return response.data;
};

// تغيير كلمة المرور
export const changePassword = async (data) => {
  const response = await api.post('/auth/change-password', data);
  return response.data;
};


export const logout = () => {
  localStorage.removeItem('token');
};

export const getHero = async () => {
  const response = await api.get('/hero');
  return response.data;
};

export const updateHero = async (heroData) => {
  const response = await api.put('/hero', heroData);
  return response.data;
};

export const uploadHeroImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  const response = await api.post('/hero/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};


export const getAbout = async () => {
  const response = await api.get('/about');
  return response.data;
};

export const updateAbout = async (aboutData) => {
  const response = await api.put('/about', aboutData);
  return response.data;
};

export const uploadAboutImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  const response = await api.post('/about/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};


export const getProjects = async () => {
  const response = await api.get('/projects');
  return response.data;
};

export const getProjectById = async (id) => {
  const response = await api.get(`/projects/${id}`);
  return response.data;
};

export const createProject = async (projectData) => {
  const response = await api.post('/projects', projectData);
  return response.data;
};

export const updateProject = async (id, projectData) => {
  const response = await api.put(`/projects/${id}`, projectData);
  return response.data;
};

export const deleteProject = async (id) => {
  const response = await api.delete(`/projects/${id}`);
  return response.data;
};

export const uploadProjectImage = async (projectId, formData) => {
  const response = await api.post(`/projects/${projectId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
export const deleteProjectImage = async (imageId) => {
  const response = await api.delete(`/projects/images/${imageId}`);
  return response.data;
};

// ============================================
// Contact APIs
// ============================================
export const getContactInfo = async () => {
  const response = await api.get('/contact/info');
  return response.data;
};

export const updateContactInfo = async (contactData) => {
  const response = await api.put('/contact/info', contactData);
  return response.data;
};

export const sendContactMessage = async (messageData) => {
  const response = await api.post('/contact/message', messageData);
  return response.data;
};

export const getContactMessages = async () => {
  const response = await api.get('/contact/messages');
  return response.data;
};

export const markMessageAsRead = async (id) => {
  const response = await api.put(`/contact/messages/${id}/read`);
  return response.data;
};

export default api;